import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(
  app,
  process.env.REACT_APP_FUNCTIONS_REGION || "australia-southeast1"
);

// Dev convenience: when REACT_APP_USE_EMULATOR=true (or unset on localhost),
// point every SDK at the local Firebase emulators so you can work without
// deploying Cloud Functions (Blaze plan).
const useEmulator =
  process.env.REACT_APP_USE_EMULATOR === "true" ||
  (process.env.REACT_APP_USE_EMULATOR !== "false" &&
    typeof window !== "undefined" &&
    window.location.hostname === "localhost");

if (useEmulator) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
  // eslint-disable-next-line no-console
  console.info("[firebase] Using local emulators (Auth/Firestore/Storage/Functions)");
}

export default app;
